<main class="default_component_structure">
  <div class="loading-overlay" *ngIf="isLoading">
    <app-spinner-animation></app-spinner-animation>
  </div>

  <div class="indicadores__wrapper" [class.indicadores__wrapper--loading]="isLoading"
       [ngStyle]="{ '--indicador-bg': corPrimaria, '--indicador-accent': corSecundaria }">
    <app-indicador-card 
      *ngFor="let card of cardsSuperiores"
      [icon]="card.icon"
      [label]="card.label"
      [value]="card.value"
      [suffix]="card.suffix">
    </app-indicador-card>
  </div>
  
  <app-filtros 
    class="default_component_structure__filtros mb-1" 
    [filtros]="filtros"
    (onSearch)="filtrar($event)">
  </app-filtros>

  <section class="default_component_structure__content">
    <div class="default_component_structure__content__wrapper relative">
      <div class="visao-geral-grid">
        <div class="col-left">
          <div class="card card-dashboards">
            <div class="card-header">
              <h2>Dashboards</h2>
            </div>
            <div class="card-body">
              <div class="graficos-grid">
                <div class="grafico-item">
                  <h3>OS's</h3>
                  <div class="grafico-content" style="padding: 0; background: transparent;" *ngIf="hasOsData">
                    <div echarts [options]="osChartOptions" style="width: 100%; height: 100%;"></div>
                  </div>
                  <div class="sem-dados-grafico" *ngIf="!hasOsData && !isLoading">
                    Não existem OS's
                  </div>
                </div>

                <div class="grafico-item">
                  <h3>Atendimentos em Geral</h3>
                  <div class="grafico-content" style="padding: 0; background: transparent;" *ngIf="hasAtendimentosGeralData">
                    <div echarts [options]="atendimentosGeralChartOptions" style="width: 100%; height: 100%;"></div>
                  </div>
                  <div class="sem-dados-grafico" *ngIf="!hasAtendimentosGeralData && !isLoading">
                    Não existem Atendimentos em Geral
                  </div>
                </div>

                <div class="grafico-item">
                  <h3>Sinistro</h3>
                  <div class="grafico-content" style="padding: 0; background: transparent;" *ngIf="hasSinistroData">
                    <div echarts [options]="sinistroChartOptions" style="width: 100%; height: 100%;"></div>
                  </div>
                  <div class="sem-dados-grafico" *ngIf="!hasSinistroData && !isLoading">
                    Não existem Sinistros
                  </div>
                </div>

                <div class="grafico-item">
                  <h3>Atendimentos do Mês</h3>
                  <div class="grafico-content" style="padding: 0; background: transparent;" *ngIf="hasAtendimentosMesData">
                    <div echarts [options]="atendimentosMesChartOptions" style="width: 100%; height: 100%;"></div>
                  </div>
                  <div class="sem-dados-grafico" *ngIf="!hasAtendimentosMesData && !isLoading">
                    Não existem Atendimentos do Mês
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-right">
          <div class="card card-infracoes">
            <div class="card-header">
              <h2>Infrações por tipo</h2>
            </div>
            <div class="card-body tabela-body">
              <app-dashboard-table
                [items]="infracoesData"
                [colunas]="infracoesColumns"
                [isLoading]="isLoading"
                emptyMessage="Nenhuma infração encontrada"
                [hasDataAll]="infracoesDataAll.length > 0"
                [paginatorLength]="infracoesPaginator.length"
                [pageSize]="infracoesPaginator.pageSize"
                [pageSizeOptions]="infracoesPaginator.pageSizeOptions"
                [pageIndex]="infracoesPaginator.pageIndex"
                (pageChanged)="onPaginateInfracoes($event)">
              </app-dashboard-table>
            </div>
          </div>

          <div class="row-bottom">
            <div class="card card-multas-local">
              <div class="card-header">
                <h2>Multas por Local</h2>
              </div>
              <div class="card-body tabela-body">
                <app-dashboard-table
                  [items]="multasLocalData"
                  [colunas]="multasLocalColumns"
                  [isLoading]="isLoading"
                  emptyMessage="Nenhuma multa encontrada"
                  [hasDataAll]="multasLocalDataAll.length > 0"
                  [paginatorLength]="multasLocalPaginator.length"
                  [pageSize]="multasLocalPaginator.pageSize"
                  [pageSizeOptions]="multasLocalPaginator.pageSizeOptions"
                  [pageIndex]="multasLocalPaginator.pageIndex"
                  (pageChanged)="onPaginateMultasLocal($event)">
                </app-dashboard-table>
              </div>
            </div>

            <div class="card card-top-multados">
              <div class="card-header">
                <h2>Top 10 Multados</h2>
              </div>
              <div class="card-body tabela-body">
                <app-dashboard-table
                  [items]="topMultadosData"
                  [colunas]="topMultadosColumns"
                  [isLoading]="isLoading"
                  emptyMessage="Nenhum veículo encontrado"
                  [hasDataAll]="topMultadosDataAll.length > 0"
                  [paginatorLength]="topMultadosPaginator.length"
                  [pageSize]="topMultadosPaginator.pageSize"
                  [pageSizeOptions]="topMultadosPaginator.pageSizeOptions"
                  [pageIndex]="topMultadosPaginator.pageIndex"
                  (pageChanged)="onPaginateTopMultados($event)">
                </app-dashboard-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
